import React from "react";

const Logo = () => {
  return <span className="logo">MW</span>;
};

export default Logo;
